<template>
  <div class="wrapper">
    <p style=";text-align: center;font-family: 等线;font-size: 14px;white-space: normal">
      <strong><span style="font-size: 19px"><span style="font-family:等线">爱艺术老师端</span>第三方SDK目录</span></strong>
    </p>
    <p style="font-size: medium;white-space: normal;margin-left: 48px">
      <span style="font-family: 等线;font-weight: bold;font-size: 16px">一、&nbsp;</span><strong><span style="font-family: 等线;font-size: 16px"><span style="font-family:等线">第三方</span>SDK列表</span></strong>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong><span style="font-family:等线">微信支付</span> SDK</strong>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>涉及个人信息：</strong><span style="font-size: 14px"><span style="font-family:等线">设备标识符（</span>Android</span><span style="font-size: 14px">：</span><span style="font-size: 14px">Android ID</span><span style="font-size: 14px"><span style="font-family:等线">，</span>iOS：IDFV、IDFA</span><span style="font-size: 14px"><span style="font-family:等线">）、</span>WLAN接入点</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>使用目的：</strong><span style="font-size: 14px">支持微信支付</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>使用的敏感权限：</strong><span style="font-size: 14px">无</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>使用场景：</strong><span style="font-size: 14px">在用户使用微信支付时使用</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>合作方主体：</strong><span style="font-size: 14px">财富通支付科技有限公司</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>收集方式：</strong><span style="font-size: 14px">SDK采集</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>合作方官网链接：</strong><a href="https://www.tenpay.com/v4/index.html"><span style="text-decoration:underline;"><span style="color: rgb(0, 0, 255)">https://www.tenpay.com/v4/index.html</span></span></a><span style="font-size: 14px">&nbsp;</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>合作方隐私政策：</strong><a href="https://www.tenpay.com/v3/helpcenter/low/privacy.shtml"><span style="text-decoration:underline;"><span style="color: rgb(0, 0, 255)">https://www.tenpay.com/v3/helpcenter/low/privacy.shtml</span></span></a><span style="font-size: 14px">&nbsp;</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <span style="font-size: 14px">&nbsp;</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong><span style="font-family:等线">友盟</span> umeng SDK</strong>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
    <strong>涉及包名信息：</strong><span style="font-size: 14px"></span><span style="font-size: 14px"></span><span style="font-size: 14px">&nbsp;</span><span style="font-size: 14px">com.uc.crashsdk、com.efs、com.umeng</span>
</p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>涉及个人信息：</strong><span style="font-size: 14px">设备标识符（</span><span style="font-size: 14px">Android</span><span style="font-size: 14px">&nbsp;</span><span style="font-size: 14px">ID）、运营商信息、运行列表信息、获取运行中进程、获取设备序列号</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>使用的敏感权限：</strong><span style="font-size: 14px">READ_PHONE_STATE</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>使用目的：</strong><span style="font-size: 14px">统计分析</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>使用场景：</strong><span style="font-size: 14px"><span style="font-family:等线">在用户使用</span>App时使用</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <span style="font-size: 14px">合作方主体：友盟同欣（北京）科技有限公司</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <span style="font-size: 14px"><span style="font-family:等线">收集方式：</span>SDK采集</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <span style="font-size: 14px">合作方官网链接：</span><a href="https://developer.umeng.com/docs/147377/detail/210024"><span style="text-decoration:underline;"><span style="color: rgb(0, 0, 255)">https://developer.umeng.com/docs/147377/detail/210024</span></span></a><span style="font-size: 14px">&nbsp;</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <span style="font-size: 14px">合作方隐私政策：</span><a href="https://developer.umeng.com/docs/147377/detail/209997"><span style="text-decoration:underline;"><span style="color: rgb(0, 0, 255)">https://developer.umeng.com/docs/147377/detail/209997</span></span></a><span style="font-size: 14px">&nbsp;</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <span style="font-size: 14px">&nbsp;</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong><span style="font-family:等线">微信</span> SDK</strong>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>涉及个人信息：</strong><span style="font-size: 14px"><span style="font-family:等线">设备标识符（</span>Android</span><span style="font-size: 14px">：</span><span style="font-size: 14px">Android ID，iOS</span><span style="font-size: 14px">：</span><span style="font-size: 14px">IDFV）、WLAN接入点、分享图片或内容</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>使用的敏感权限：</strong><span style="font-size: 14px">无</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>使用目的：</strong><span style="font-size: 14px">支持微信分享</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>使用场景：</strong><span style="font-size: 14px">在用户分享时使用</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>合作方主体：</strong><span style="font-size: 14px">深圳市腾讯计算机系统有限公司</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>收集方式：</strong><span style="font-size: 14px">SDK采集</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>合作方官网链接：</strong><a href="https://open.weixin.qq.com"><span style="text-decoration:underline;"><span style="color: rgb(0, 0, 255)">https://open.weixin.qq.com</span></span></a><span style="font-size: 14px">&nbsp;</span>
    </p>
    <p style="margin: 0 0 0 7px;text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>合作方隐私政策：</strong><a href="https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJkLOrQwu0nb8"><span style="text-decoration:underline;"><span style="color: rgb(0, 0, 255)">https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJkLOrQwu0nb8</span></span></a><span style="font-size: 14px">&nbsp;</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <span style="font-size: 14px">&nbsp;</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong><span style="font-family:等线">微博</span> SDK</strong>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>涉及个人信息：</strong><span style="font-size: 14px"><span style="font-family:等线">设备标识符（</span>Android</span><span style="font-size: 14px">：</span><span style="font-size: 14px">Android ID、GUID、OAID，iOS</span><span style="font-size: 14px">：</span><span style="font-size: 14px">IDFV、IDFA）</span><span style="font-size: 14px">、</span><span style="font-size: 14px">&nbsp;<span style="font-family:等线">位置信息（</span>GPS、WLAN接入点）、分享图片或内容、设备传感器、应用列表</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>使用的敏感权限：</strong><span style="font-size: 14px">无</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>使用目的：</strong><span style="font-size: 14px">帮助用户分享内容至第三方应用</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>使用场景：</strong><span style="font-size: 14px">在用户将内容分享至微博时使用</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>合作方主体：</strong><span style="font-size: 14px">北京微梦创科网络技术有限公司</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>收集方式：</strong><span style="font-size: 14px">SDK采集</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>官网链接：</strong><a href="https://open.weibo.com/wiki/SDK"><span style="text-decoration:underline;"><span style="color: rgb(0, 0, 255)">https://open.weibo.com/wiki/SDK</span></span></a><span style="font-size: 14px">&nbsp;</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>隐私政策：</strong><a href="https://weibo.com/signup/v5/privacy"><span style="text-decoration:underline;"><span style="color: rgb(0, 0, 255)">https://weibo.com/signup/v5/privacy</span></span></a><span style="font-size: 14px">&nbsp;</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <span style="font-size: 14px">&nbsp;</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong><span style="font-family:等线">阿里云</span>SDK</strong>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>涉及个人信息：</strong><span style="font-family: DengXian;color: rgb(51, 51, 51);font-size: 14px;background: rgb(255, 255, 255)"><span style="font-family:DengXian">网络类型、设备信息（含</span>IP地址、设备制造商、设备型号、手机操作系统、SIM卡信息SIM State）。</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>使用的敏感权限：</strong><span style="font-size: 14px">无</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>使用目的：</strong><span style="font-size: 14px">一键登录</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>使用场景：</strong><span style="font-size: 14px">一键登录验证</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>合作方主体：</strong><span style="font-size: 14px">阿里云计算有限公司、蚂蚁区块链科技（上海）有限公司</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>收集方式：</strong><span style="font-size: 14px">SDK采集</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>合作方官网链接：</strong><a href="https://www.aliyun.com"><span style="text-decoration:underline;"><span style="color: rgb(0, 0, 255)">https://www.aliyun.com</span></span></a><span style="font-size: 14px">&nbsp;</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>合作方隐私政策：</strong><a href="http://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud201902141711_54837.html?spm=5176.146391.7y9jhqsfz.86.2d155e3bbHRayX"><span style="text-decoration:underline;"><span style="color: rgb(0, 0, 255)">http://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud201902141711_54837.html?spm=5176.146391.7y9jhqsfz.86.2d155e3bbHRayX</span></span></a><span style="font-size: 14px">&nbsp;</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <span style="font-size: 14px">&nbsp;</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>七牛</strong><strong>SDK</strong>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>涉及个人信息：</strong><span style="color: rgb(55, 71, 79);font-size: 14px"><span style="font-family:等线">厂商、机型、系统版本</span> <span style="font-family:等线">用于判断用户的的手机类型，以备兼容性及问题排查。网络类型（</span>Wi-FI、3G、4G）用于通信质量不佳时的问题排查</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>使用的敏感权限：</strong><span style="font-size: 14px">无</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>使用目的：</strong><span style="font-size: 14px">文件上传</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>使用场景：</strong><span style="font-size: 14px">用户上传图片和视频内容</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>合作方主体：</strong><span style="font-size: 14px">上海七牛信息技术有限公司</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>收集方式：</strong><span style="font-size: 14px">SDK采集</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>合作方官网链接：</strong><a href="https://www.qiniu.com"><span style="text-decoration:underline;"><span style="color: rgb(0, 0, 255)">https://www.qiniu.com</span></span></a><span style="font-size: 14px">&nbsp;</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>合作方隐私政策：</strong><a href="https://www.qiniu.com/agreements/privacy-right"><span style="text-decoration:underline;"><span style="color: rgb(0, 0, 255)">https://www.qiniu.com/agreements/privacy-right</span></span></a><span style="font-size: 14px">&nbsp;</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <span style="font-size: 14px">&nbsp;</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong><span style="font-family:等线">腾讯即时通信</span>SDK</strong>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>涉及个人信息：</strong><span style="font-family: DengXian;font-size: 14px;background: rgb(255, 255, 255)"><span style="font-family:DengXian">运营商信息、</span>SSID</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>使用的敏感权限：</strong><span style="font-size: 14px">无</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>使用目的：</strong><span style="font-size: 14px">即时通信</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>使用场景：</strong><span style="font-size: 14px">用户聊天室会话</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>合作方主体：</strong><span style="font-size: 14px">腾讯云计算（北京）有限责任公司</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>收集方式：</strong><span style="font-size: 14px">SDK采集</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>合作方官网链接：</strong><a href="https://cloud.tencent.com"><span style="text-decoration:underline;"><span style="color: rgb(0, 0, 255)">https://cloud.tencent.com</span></span></a><span style="font-size: 14px">&nbsp;</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>合作方隐私政策：</strong><a href="https://cloud.tencent.com/document/product/301/11470"><span style="text-decoration:underline;"><span style="color: rgb(0, 0, 255)">https://cloud.tencent.com/document/product/301/11470</span></span></a><span style="font-size: 14px">&nbsp;</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <span style="font-size: 14px">&nbsp;</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>移动一键登录</strong>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>涉及个人信息：</strong><span style="font-size: 14px"><span style="font-family:等线">设备标识符（</span>Android</span><span style="font-size: 14px">：</span><span style="font-size: 14px">Android ID，iOS</span><span style="font-size: 14px">：</span><span style="font-size: 14px">IDFV）、IP地址、蓝牙、本机号码</span><span style="font-size: 14px"><span style="font-family:等线">、</span>SIM卡状态信息、运营商信息</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>使用的敏感权限：</strong><span style="font-size: 14px">无</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>使用目的：</strong><span style="font-size: 14px">一键登录</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>使用场景：</strong><span style="font-size: 14px">在用户使用移动手机号一键登录时使用</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>合作方主体：</strong><span style="font-size: 14px">中移互联网有限公司</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>收集方式：</strong><span style="font-size: 14px">SDK采集</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>合作方官网链接：</strong><a href="http://dev.10086.cn/numIdentific"><span style="text-decoration:underline;"><span style="color: rgb(0, 0, 255)">http://dev.10086.cn/numIdentific</span></span></a><span style="font-size: 14px">&nbsp;</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>合作方隐私政策：</strong><a href="https://wap.cmpassport.com/resources/html/contract.html"><span style="text-decoration:underline;"><span style="color: rgb(0, 0, 255)">https://wap.cmpassport.com/resources/html/contract.html</span></span></a><span style="font-size: 14px">&nbsp;</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <span style="font-size: 14px">&nbsp;</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>联通一键登录</strong>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>涉及个人信息：</strong><span style="font-size: 14px">设备标识</span><span style="font-size: 14px">符</span><span style="font-size: 14px"><span style="font-family:等线">、</span>IP地址、SSID、蓝牙、本机号码</span><span style="font-size: 14px"><span style="font-family:等线">、</span>SIM卡状态信息、运营商信息</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>使用的敏感权限：</strong><span style="font-size: 14px">无</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>使用目的：</strong><span style="font-size: 14px">一键登录</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>使用场景：</strong><span style="font-size: 14px">在用户使用联通手机号一键登录时使用</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>合作方主体：</strong><span style="font-size: 14px">中国联合网络通信有限公司</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>收集方式：</strong><span style="font-size: 14px">SDK采集</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>合作方官网链接：</strong><a href="https://onlinebusiness.10010.com/product/5302?chnl=none"><span style="text-decoration:underline;"><span style="color: rgb(0, 0, 255)">https://onlinebusiness.10010.com/product/5302?chnl=none</span></span></a><span style="font-size: 14px">&nbsp;</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>合作方隐私政策：</strong><a href="https://opencloud.wostore.cn/authz/resource/html/disclaimer.html"><span style="text-decoration:underline;"><span style="color: rgb(0, 0, 255)">https://opencloud.wostore.cn/authz/resource/html/disclaimer.html</span></span></a><span style="font-size: 14px">&nbsp;</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <span style="font-size: 14px">&nbsp;</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>电信一键登录</strong>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>涉及个人信息：</strong><span style="font-size: 14px"><span style="font-family:等线">设备标识符（</span>Android</span><span style="font-size: 14px">：</span><span style="font-size: 14px">Android ID</span><span style="font-size: 14px">，</span><span style="font-size: 14px">iOS</span><span style="font-size: 14px">：</span><span style="font-size: 14px">IDFV）、IP地址、蓝牙、本机号码</span><span style="font-size: 14px"><span style="font-family:等线">、</span>SIM卡状态信息、运营商信息</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>使用的敏感权限：</strong><span style="font-size: 14px">无</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>使用目的：</strong><span style="font-size: 14px">一键登录</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>使用场景：</strong><span style="font-size: 14px">在用户使用电信手机号一键登录时使用</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>合作方主体：</strong><span style="font-size: 14px">世纪龙信息网络有限责任公司</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>收集方式：</strong><span style="font-size: 14px">SDK采集</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>合作方官网链接：</strong><a href="http://id.189.cn/api?initialSrc=/html/api_detail_634.html"><span style="text-decoration:underline;"><span style="color: rgb(0, 0, 255)">http://id.189.cn/api?initialSrc=/html/api_detail_634.html</span></span></a><span style="font-size: 14px">&nbsp;</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>合作方隐私政策：</strong><a href="https://e.189.cn/sdk/agreement/content.do?type=main&appKey=&hidetop=true&returnUrl="><span style="text-decoration:underline;"><span style="color: rgb(0, 0, 255)">https://e.189.cn/sdk/agreement/content.do?type=main&amp;appKey=&amp;hidetop=true&amp;returnUrl=</span></span></a><span style="font-size: 14px">&nbsp;</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <span style="font-size: 14px">&nbsp;</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>AliFastJson</strong>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>涉及个人信息：</strong><span style="font-size: 14px">无</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>使用的敏感权限：</strong><span style="font-size: 14px">无</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>使用目的：</strong><span style="font-size: 14px">数据解析</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>使用场景：</strong><span style="font-size: 14px">解析数据时使用</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>合作方主体：</strong><span style="font-size: 14px">阿里云计算有限公司</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>收集方式：</strong><span style="font-size: 14px">SDK采集</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>合作方官网链接：</strong><a href="https://www.aliyun.com"><span style="text-decoration:underline;"><span style="color: rgb(0, 0, 255)">https://www.aliyun.com</span></span></a><span style="font-size: 14px">&nbsp;</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>合作方隐私政策：</strong><a href="http://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud201902141711_54837.html?spm=5176.146391.7y9jhqsfz.86.2d155e3bbHRayX"><span style="text-decoration:underline;"><span style="color: rgb(0, 0, 255)">http://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud201902141711_54837.html?spm=5176.146391.7y9jhqsfz.86.2d155e3bbHRayX</span></span></a><span style="font-size: 14px">&nbsp;</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <span style="font-size: 14px">&nbsp;</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong><span style="font-family:等线">岳鹰</span>SDK</strong>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>涉及个人信息：</strong><span style="font-size: 14px">设备信息、崩溃日志</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>使用的敏感权限：</strong><span style="font-size: 14px">无</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>使用目的：</strong><span style="font-size: 14px">实现数据监测、崩溃日志</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>使用场景：</strong><span style="font-size: 14px">登录</span><span style="font-size: 14px">/推送</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>合作方主体：</strong><span style="font-size: 14px">广州市动景计算机科技有限公司</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>收集方式：</strong><span style="font-size: 14px">SDK采集</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>合作方官网链接：</strong><a href="https://yueying-docs.effirst.com/werlcw.html"><span style="text-decoration:underline;"><span style="color: rgb(0, 0, 255)">https://yueying-docs.effirst.com/werlcw.html</span></span></a><span style="font-size: 14px">&nbsp;</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>合作方隐私政策：</strong><a href="https://terms.alicdn.com/legal-agreement/terms/suit_bu1_uc/suit_bu1_uc202108181503_97480.html"><span style="text-decoration:underline;"><span style="color: rgb(0, 0, 255)">https://terms.alicdn.com/legal-agreement/terms/suit_bu1_uc/suit_bu1_uc202108181503_97480.html</span></span></a><span style="font-size: 14px">&nbsp;</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <span style="font-size: 14px">&nbsp;</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>Bugly</strong><strong>&nbsp;</strong><strong>SDK</strong>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>涉及个人信息：</strong><span style="font-family: DengXian;font-size: 14px;background: rgb(255, 255, 255)"><span style="font-family:DengXian">手机品牌、</span>Android系统版本、Android系统api等级、厂商系统版本、cpu架构类型、设备是否root、磁盘空间占用大小、sdcard空间占用大小、内存空间占用大小、网络类型、应用当前正在运行的进程名和PID、获取运行中进程</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>使用的敏感权限：</strong><span style="font-size: 14px">无</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>使用目的：</strong><span style="font-size: 14px"><span style="font-family:等线">排查崩溃问题，帮助</span>App提升稳定性</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>使用场景：</strong><span style="font-size: 14px">应用质量监控以及异常低定位分析</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>合作方主体：</strong><span style="font-size: 14px">深圳市腾讯计算机系统有限公司</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>收集方式：</strong><span style="font-size: 14px">SDK采集</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>合作方官网链接：</strong><a href="https://www.tencent.com/zh-cn"><span style="text-decoration:underline;"><span style="color: rgb(0, 0, 255)">https://www.tencent.com/zh-cn</span></span></a><span style="font-size: 14px">&nbsp;</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <strong>合作方隐私政策：</strong><a href="https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56"><span style="text-decoration:underline;"><span style="color: rgb(0, 0, 255)">https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56</span></span></a><span style="font-size: 14px">&nbsp;</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
      <span style="font-size: 14px">&nbsp;</span>
    </p>
    <p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
    <strong><span style="font-family:等线">高德地图</span>SDK</strong>
</p>
<p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
    <strong>涉及个人信息：</strong><span style="font-size: 14px">位置信息、应用信息（应用名、应用版本号）、设备品牌及型号</span>
</p>
<p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
    <strong><span style="font-family:等线">使用的敏感权限：</span><a></a></strong><span style="font-size: 14px">无</span>
</p>
<p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
    <strong>使用目的：</strong><span style="font-size: 14px">为用户提供地图导航、搜索附近功能</span>
</p>
<p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
    <strong>使用场景：</strong><span style="font-size: 14px">在用户选择地图导航、搜索附近功能时使用</span>
</p>
<p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
    <strong>合作方主体：</strong><span style="font-size: 14px">高德软件有限公司</span>
</p>
<p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
    <strong>收集方式：</strong><span style="font-size: 14px">SDK采集</span>
</p>
<p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
    <strong>合作方官网链接</strong><strong>：</strong><a href="https://lbs.amap.com/"><span style="text-decoration:underline;"><span style="font-family: &#39;Times New Roman&#39;;color: rgb(0, 0, 255)">https://lbs.amap.com/</span></span></a><span style="font-size: 14px">&nbsp;</span><a href="https://lbs.amap.com/"></a>
</p>
<p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
    <strong>合作方隐私政策：</strong><span style="font-size: 14px">&nbsp;</span><a href="https://cache.amap.com/h5/h5/publish/238/index.html"><span style="text-decoration:underline;"><span style="font-family: &#39;Times New Roman&#39;;color: rgb(0, 0, 255)">https://cache.amap.com/h5/h5/publish/238/index.html</span></span></a><span style="font-size: 14px">&nbsp;</span>
</p>
<p style=";text-align: justify;font-family: 等线;font-size: 14px;white-space: normal">
    <span style="font-size: 14px">&nbsp;</span>
</p>
    <p>
      <br />
    </p>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.wrapper {
  background: #fff;
  border-radius: 10px;
  padding: 16px;
  font-size: 14px;
  line-height: 28px;
  color: rgb(0, 0, 0);
  word-break: break-all;
}
</style>